import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchAISummaryFromData } from "./ai.thunk";

const INIT_STATE = {
  summary: "",
  loadingSummary: true,
  productSummary: "",
  loadingProductSummary: true,
};

export const fetchAISummaryFromDataAsyncThunk = createAsyncThunk(
  "fetchAISummaryFromData",
  fetchAISummaryFromData
);

const aiSlice = createSlice({
  name: "ai data",
  initialState: INIT_STATE,
  reducers: {
    resetSummary: (state) => {
      state.summary = "";
      state.loadingSummary = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAISummaryFromDataAsyncThunk.pending, (state, action) => {
        if (action.meta.arg.type === "PRODUCT") {
          state.productSummary = "";
          state.loadingProductSummary = true;
        } else {
          state.summary = "";
          state.loadingSummary = true;
        }

        return state;
      })
      .addCase(fetchAISummaryFromDataAsyncThunk.fulfilled, (state, action) => {
        if (action.meta.arg.type === "PRODUCT") {
          state.productSummary = action.payload.data;
          state.loadingProductSummary = false;
        } else {
          state.summary = action.payload.data;
          state.loadingSummary = false;
        }
        return state;
      })
      .addCase(fetchAISummaryFromDataAsyncThunk.rejected, (state, action) => {
        if (action.meta.arg.type === "PRODUCT") {
          state.loadingProductSummary = false;
        } else {
          state.loadingSummary = false;
        }
        return state;
      });
  },
});

export const { resetSummary } = aiSlice.actions;
export default aiSlice.reducer;
